export default __webpack_public_path__ + "static/media/no-coloured-teacher.676233f0.svg";